import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Spinner, SpinnerSize, SpinnerStyle, SpinnerWeight} from '@mintdata-wsp/common/components/spinner/Spinner';
import {CopyPagesState, DesignInfo, ProjectInfo,} from '@mintdata-wsp/common/state/ui/visualDesigner/CopyPagesState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {CustomDropdown} from '@mintdata-wsp/wsp/ui/components/customDropdown/CustomDropdown';
import {Input, InputStyle} from '@mintdata-wsp/wsp/ui/components/forms/Input';
import {HighlightedText} from '@mintdata-wsp/wsp/ui/components/text/HighlightedText';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SpaceDesignDropdown.less');
const cx = classnames.bind(styles);

interface SpaceDesignDropdownProps
{
    className?:string,
}

@observer
export class SpaceDesignDropdown extends React.Component<SpaceDesignDropdownProps, any>
{
    @bind
    private _handleDropdownClick():void
    {
        const {copyPages} = controllers.ui;
        copyPages.loadDesignsAsync(true);
    }

    @bind
    private _handleSearchValueChange(newValue?:string):void
    {
        const {copyPages} = controllers.ui;
        copyPages.setDesignsSearchString(newValue || null);
    }

    @bind
    private _getListItemClickHandler(design:DesignInfo, closePopoverFunc:() => void):(event:React.MouseEvent<any>) => void
    {
        return (event:React.MouseEvent<any>):any =>
        {
            const {copyPages} = controllers.ui;

            closePopoverFunc();
            controllers.ui.copyPages.onDesignSelected(design.id, copyPages.generateProjectAndDesignName(design.projectName, design.name));
        };
    }

    @bind
    private _renderSpaceDesignList(closePopoverFunc:() => void):JSX.Element
    {
        const {copyPages} = controllers.ui;
        const copyState:CopyPagesState = copyPages.getState();
        const {
            designState: {selectedDesignId},
            projectsFiltered,
            designsSearchString,
            designsLoading
        } = copyState;

        return (
            <div className={cx('list')}>
                <Input
                    icon={MDIcons.common.Search}
                    placeholder="Search by space or design name..."
                    className={cx('searchWrapper')}
                    inputClassName={cx('searchInput')}
                    style={InputStyle.Simple}
                    initialValue={designsSearchString}
                    isInitiallySelected={true}
                    isInitiallyFocused={true}
                    onChange={this._handleSearchValueChange}
                />
                <div className={cx('searchResults')}>
                    {designsLoading && <div
                        className={cx('spinnerWrapper')}
                    >
                        <Spinner
                            size={SpinnerSize.Medium_24}
                            style={SpinnerStyle.Blue}
                            className={cx('spinner')}
                            weight={SpinnerWeight.Thin}
                        />
                    </div>
                    }

                    {!designsLoading && projectsFiltered.map((project:ProjectInfo) => (
                        <div className={cx('projectItem')} key={project.id}>
                            <div className={cx('projectName')}>
                                <HighlightedText text={project.name} partToHighlight={designsSearchString} />
                            </div>

                            {project.designs.map((design:DesignInfo) => (
                                <div
                                    className={cx('listItem')}
                                    onClick={this._getListItemClickHandler(design, closePopoverFunc)}
                                    key={design.id}
                                >
			                        <span className={cx('iconWrapper')}>
			                            {selectedDesignId === design.id && <MDIcon
                                            className={cx('icon')}
                                            name={MDIcons.common.Checkmark}
                                            size={MDIconSize.medium16}
                                        />}
			                        </span>
                                    <span className={cx('title')}>
							            {project.name.toLowerCase()
                                            .indexOf((designsSearchString || '').trim().toLowerCase()) > -1
                                            ? design.name
                                            :
                                            <HighlightedText text={design.name} partToHighlight={designsSearchString} />
                                        }
						            </span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render():JSX.Element | false | null
    {
        const {className} = this.props;
        const {copyPages} = controllers.ui;
        const copyPagesState:CopyPagesState = copyPages.getState();
        const isDisabled:boolean = !copyPagesState.designState.selectedDesignId;

        return <CustomDropdown
            className={cx('base', {[className]: !!className})}
            title={copyPagesState.selectedProjectAndDesignName}
            onPopoverClose={this._handleSearchValueChange}
            renderListFunc={this._renderSpaceDesignList}
            onClick={this._handleDropdownClick}
            disabled={isDisabled}
            ddIconClassName={cx({hidden: isDisabled})}
        />;
    }
}
